import { ImgHTMLAttributes, useMemo } from 'react';

import {
  decodeConfigFromUrl,
  getBaseUrlWithoutQuery,
} from '../../../../../../helpers/common';
import { useClassHelper } from '../../../../../../hooks/useClassHelper';
import { WebsheetLogoPlaceHolder } from '../../../../components/WebsheetLogoPlaceHolder';
import { componentName } from '../../constants';

type ImageType = Omit<ImgHTMLAttributes<HTMLImageElement>, 'className'>;

interface Props extends ImageType {
  // Branding is optional: with no logo the live websheet renders nothing, and
  // the Portal preview shows a placeholder so the builder sees the slot.
  isPortalPreview?: boolean;
}

export const HeaderImage = ({ isPortalPreview = false, ...props }: Props) => {
  const c = useClassHelper(componentName);
  const logoUrl = props.src;

  const imageConfig = useMemo(() => {
    return decodeConfigFromUrl(logoUrl || '');
  }, [logoUrl]) as any;

  const imageUrlWithoutConfig = useMemo(() => {
    return getBaseUrlWithoutQuery(logoUrl || '');
  }, [logoUrl]);

  const imgStyle = useMemo(() => {
    const style: React.CSSProperties = {};

    if (imageConfig?.imageSize) {
      style.height = imageConfig.imageSize + 'px';
    } else {
      style.height = '60px';
    }

    return style;
  }, [imageConfig]);

  if (!imageUrlWithoutConfig) {
    if (isPortalPreview) {
      return <WebsheetLogoPlaceHolder />;
    }

    return null;
  }

  return (
    <img
      alt="logo header"
      className={c('__header-image')}
      {...props}
      src={imageUrlWithoutConfig}
      style={imgStyle}
    />
  );
};
